"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PDF = require("./PDF");

Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PDF).default;
  }
});

var _Page = require("./Page");

Object.defineProperty(exports, "Page", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Page).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }